module.exports = __webpack_public_path__ + "static/img/light.593a7ce.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/me-lesson/light.png
// module id = L0jf
// module chunks = 1